import { useState } from 'react'
import { ChevronUp, ChevronDown } from 'lucide-react'

interface EdgeBlurSliderProps {
  onChange: (value: number) => void
}

export function EdgeBlurSlider({ onChange }: EdgeBlurSliderProps) {
  const [value, setValue] = useState(0)
  const [isExpanded, setIsExpanded] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value)
    setValue(newValue)
    onChange(newValue)
  }

  const toggleExpanded = () => setIsExpanded(!isExpanded)

  return (
    <div className="relative">
      <button
        onClick={toggleExpanded}
        className="p-2 rounded-md bg-white/80 backdrop-blur-sm shadow-lg text-gray-800 hover:bg-gray-200 transition-colors"
        aria-label={isExpanded ? "Collapse edge blur slider" : "Expand edge blur slider"}
      >
        {isExpanded ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
      </button>
      {isExpanded && (
        <div className="absolute right-0 mt-2 p-4 bg-white/80 backdrop-blur-sm rounded-lg shadow-lg w-64">
          <label htmlFor="edge-blur" className="block text-sm font-medium text-gray-700 mb-2">
            Edge Blur: {value}px
          </label>
          <input
            type="range"
            id="edge-blur"
            min={0}
            max={20}
            step={1}
            value={value}
            onChange={handleChange}
            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
          />
        </div>
      )}
    </div>
  )
} 